var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.965 7.666c0 .404.176.703.492 1.037l5.941 5.96c.229.228.545.368.915.368.72 0 1.265-.58 1.265-1.283 0-.387-.14-.703-.387-.95l-2.197-2.161-2.127-1.793 3.727.14h9.158c.773 0 1.318-.562 1.318-1.318s-.562-1.318-1.318-1.318H8.594l-3.71.14 2.11-1.775 2.197-2.18c.229-.228.387-.545.387-.931C9.578.88 9.033.336 8.313.336c-.37 0-.686.123-.915.352L1.457 6.646c-.352.352-.492.65-.492 1.02"
  })));
};
export default SvgArrow;